import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(theme => {
  var _theme$palette, _theme$palette2, _theme$palette3;
  return {
    content: {
      padding: '0 4px'
    },
    section: {
      marginBottom: 20
    },
    sectionTitle: {
      marginBottom: 8,
      fontWeight: 600
    },
    sectionDescription: {
      marginBottom: 12,
      fontSize: 14,
      color: ((_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.text) === null || _theme$palette === void 0 ? void 0 : _theme$palette.secondary) || '#666'
    },
    pricingTypeToggle: {
      marginBottom: 20,
      '& .MuiToggleButtonGroup-root': {
        display: 'flex'
      },
      '& .MuiToggleButton-root': {
        textTransform: 'none',
        fontWeight: 600
      }
    },
    tiersTable: {
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: 12,
      '& th, & td': {
        padding: '10px 12px',
        textAlign: 'left',
        borderBottom: "1px solid ".concat(((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.divider) || '#e0e0e0')
      },
      '& th': {
        fontWeight: 600,
        fontSize: 12,
        color: ((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 || (_theme$palette3 = _theme$palette3.text) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3.secondary) || '#666',
        textTransform: 'none'
      },
      '& td': {
        verticalAlign: 'middle'
      }
    },
    tierUnitsInput: {
      width: 120
    },
    tierPriceInput: {
      width: 120
    },
    addTierButton: {
      textTransform: 'none',
      marginBottom: 20
    },
    currencyInput: {
      width: '100%',
      maxWidth: 160
    }
  };
});
export default useStyles;